const ST_REPORTS_TABLE_READY = "st-reports-table-ready"
const SEARCH_TEXT_STATE = "st-reports-table-search-text-state"
const ROWS_PER_PAGE_STATE = "st-reports-table-rows-per-page-state"
const PAGINATION_STATE = "st-reports-table-pagination-state"


const PREVIOUS_STORE_FILTER_START_DATE = "st-reports-previous-start-date"
const PREVIOUS_STORE_FILTER_END_DATE = "st-reports-previous-end-date"
//const PREVIOUS_STORE_FILTER_CITY = "st-reports-previous-city"

const initialState = {
    isSTReportsReady: true,
    stReports: {},

    previousFilterStartDate: "",
    previousFilterEndDate: "",

    
    previousSearchText: "",
    previousRowsPerPageValue: 15,
    previousPaginationValue: 1,
    
}


export default function reducer(state = initialState, action) {
    let duplicateState = null
    switch (action.type) {
        case ST_REPORTS_TABLE_READY:
            return Object.assign({}, state, { isSTReportsReady: action.payload })       


        case SEARCH_TEXT_STATE :
            duplicateState = Object.assign({}, state)
            duplicateState.previousSearchText = action.payload
            return Object.assign({}, state, duplicateState)
        
        case ROWS_PER_PAGE_STATE:
            duplicateState=Object.assign({},state)
            duplicateState.previousRowsPerPageValue= action.payload
            return Object.assign({}, state, duplicateState)
        
        case PAGINATION_STATE:
            duplicateState= Object.assign({},state)
            duplicateState.previousPaginationValue = action.payload
            return Object.assign({}, state, duplicateState)


        case PREVIOUS_STORE_FILTER_START_DATE:
            return Object.assign({}, state, {previousFilterStartDate:action.payload})
        case PREVIOUS_STORE_FILTER_END_DATE:
            return Object.assign({}, state, {previousFilterEndDate:action.payload})

        default:
        return state
    
    }

}

export function stReportsTableReady(data) {
    return {
        type: ST_REPORTS_TABLE_READY,
        payload: data
    }
}




export function searchTextState(searchText){
    return {
        type:SEARCH_TEXT_STATE,
        payload:searchText
    }
}

export function rowsPerPageState(rows){
    return {
        type:ROWS_PER_PAGE_STATE,
        payload:rows
    }
}

export function paginationState(pageNo){
    return{
        type:PAGINATION_STATE,
        payload:pageNo
    }
}


export function previousFilterStartDate(fiter_val){
    return{
        type:PREVIOUS_STORE_FILTER_START_DATE,
        payload:fiter_val
    }
}


export function previousFilterEndDate(fiter_val){
    return{
        type:PREVIOUS_STORE_FILTER_END_DATE,
        payload:fiter_val
    }
}




// WEBPACK FOOTER //
// ./src/modules/ST Reports/redux/streports.js